import { render, staticRenderFns } from "./Chatbot.vue?vue&type=template&id=5ba4a764&scoped=true"
import script from "./Chatbot.vue?vue&type=script&lang=js"
export * from "./Chatbot.vue?vue&type=script&lang=js"
import style0 from "./Chatbot.vue?vue&type=style&index=0&id=5ba4a764&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ba4a764",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/myskilliz_new/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ba4a764')) {
      api.createRecord('5ba4a764', component.options)
    } else {
      api.reload('5ba4a764', component.options)
    }
    module.hot.accept("./Chatbot.vue?vue&type=template&id=5ba4a764&scoped=true", function () {
      api.rerender('5ba4a764', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/components/theme/Chatbot.vue"
export default component.exports